/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyVersionModel } from '../../models/client-survey-version-model';
import { UpdateSurveyVersionRequest } from '../../models/update-survey-version-request';

export interface UpdateSurveyVersionAsync$Json$Params {

/**
 * surveyversion id
 */
  surveyVersionId: number;
  
    /**
     * surveyversion request variables
     */
    body?: UpdateSurveyVersionRequest
}

export function updateSurveyVersionAsync$Json(http: HttpClient, rootUrl: string, params: UpdateSurveyVersionAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
  const rb = new RequestBuilder(rootUrl, updateSurveyVersionAsync$Json.PATH, 'put');
  if (params) {
    rb.path('surveyVersionId', params.surveyVersionId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyVersionModel>;
    })
  );
}

updateSurveyVersionAsync$Json.PATH = '/api/SurveyVersion/{surveyVersionId}';
